<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-global-header slds-grid slds-grid_align-spread">

  <div class="slds-global-header__item">
    <div (click)="onClickLogo()" class="slds-global-header__logo"
         style="width: 2.5rem"
         title="(c) Accorto, Inc."></div>
  </div>

  <div [innerHTML]="appName"
       [title]="appTitle"
       class="slds-global-header__item slds-text-heading_medium slds-truncate"
       id="appTitle"></div>

  <div [title]="hdrTitle"
       class="slds-global-header__item slds-text-body_small"
       id="hdrTitle">{{hdrTitle}}</div>

  <div class="slds-global-header__item">

    <ul class="slds-global-actions">
      <li class="slds-global-actions__item">
        <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
          <button
            aria-atomic="true"
            aria-live="assertive"
            class="slds-button slds-button_icon slds-button_icon slds-button_icon-container slds-button_icon-small slds-global-actions__notifications slds-global-actions__item-action"
            id="hdrNotifications"
            title="no new notifications">
            <svg aria-hidden="true" class="slds-button__icon slds-global-header__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#notification"></use>
            </svg>
            <span class="slds-assistive-text">no new notifications</span>
          </button>
          <span aria-hidden="true" class="slds-notification-badge">0</span>
        </div>
      </li>


      <li class="slds-global-actions__item">
        <div [class.slds-is-open]="showUserMenu"
             class="slds-dropdown-trigger slds-dropdown-trigger_hover">
          <div class="slds-dropdown-trigger  slds-dropdown-trigger_hover">
            <button aria-haspopup="true"
                    class="slds-button slds-global-actions__avatar slds-global-actions__item-action"
                    id="hdrUser">
              <span class="slds-avatar slds-avatar_circle slds-avatar_medium">
                <abbr [title]="userName"
                      class="slds-avatar__initials slds-icon-standard-contact"
                      id="initials">{{initials}}</abbr>
              </span>
            </button>
            <div class="slds-dropdown slds-dropdown_right slds-nubbin_top-right"
                 style="right:-.5rem">
              <ul class="slds-dropdown__list" role="menu">
                <li class="slds-dropdown__header slds-truncate"
                    role="separator" title="Menu Sub Heading">
                  <div id="hdrUserLabel">{{userLabel}}</div>
                  <div style="font-weight: lighter; font-size: x-small">
                    <div id="hdrUserName">{{userName}}</div>
                    <div id="hdrCompanyName">{{userCompany}}</div>
                  </div>
                </li>

                <li class="slds-dropdown__item" role="presentation">
                  <a [routerLink]="['/status']" id="hdrStatus" role="menuitem" tabindex="0">
                    <span class="slds-truncate" title="Status">
                      <span class="slds-icon_container slds-m-right_x-small">
                        <acc-icon href="stage"></acc-icon>
                      </span>
                      Status
                    </span>
                  </a>
                </li>
                <li class="slds-dropdown__item" role="presentation">
                  <a (click)="onClickLogout()" id="hdrLogout" role="menuitem" tabindex="0">
                    <span class="slds-truncate" title="Logout">
                      <span class="slds-icon_container slds-m-right_x-small">
                        <acc-icon href="logout"></acc-icon>
                      </span>
                      Logout
                    </span>
                  </a>
                </li>

              </ul>
            </div>

          </div>
        </div>
      </li>
    </ul>
  </div>

</header>
